<template>
    <button class="d-flex align-items-center justify-content-center" @click="onClick">
        <div v-show="loading" class="spinner-border text-light" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div v-show="!loading">
            <slot />
        </div>
    </button>
</template>

<script>
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component()
export default class ButtonLoader extends Vue {
    @Prop({
        type: Boolean,
        required: true,
        default: false
    })
    loading

    onClick () {
        this.$emit('onClick')
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/ButtonLoader.vue